import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteBrandingSetup } from '@api/managePlatformBranding';

import { ESnackbarTypes } from '@enums/common';

import { BRANDING_SETUPS, DELETE_BRANDING_SETUP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IRemoveSingleBrandingSetupReturn {
	handleDeleteBrandingSetup: (setupId: string) => void;
	isLoadingDeleteBrandingSetup: boolean;
}

export const useMutateRemoveSingleBrandingSetup = (
	onSettledCallbacks?: Array<() => void>,
): IRemoveSingleBrandingSetupReturn => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleDeleteBrandingSetup,
		isLoading: isLoadingDeleteBrandingSetup,
	} = useMutation<string>({
		mutationKey: [DELETE_BRANDING_SETUP],
		mutationFn: deleteBrandingSetup,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.removedBrandingSetup,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([BRANDING_SETUPS]);
		},
	});

	return {
		handleDeleteBrandingSetup,
		isLoadingDeleteBrandingSetup,
	};
};
